<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <el-breadcrumb class="target" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/offline' }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>{{dataInfo.courseName}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="detail cl">
        <div class="left bs fl">
          <i class="img-wrap">
            <img :src="dataInfo.coursePic" alt />
          </i>
          <!-- <video width="100%" height="100%" controls autoplay>
            <source src="movie.mp4" type="video/mp4" />
            <source src="movie.ogg" type="video/ogg" />
          </video>-->
        </div>
        <div class="info fl">
          <h3 class="title">{{dataInfo.courseName}}</h3>
          <div class="line">
            <span>讲师: {{dataInfo.courseTeacher}}</span>
            <span class="hour">预约人数: {{dataInfo.registerCount}}人</span>
          </div>
          <div class="begin">开课时间：{{dataInfo.openingStart}} —— {{dataInfo.openingEnd}}</div>
          <div class="price">
            优惠价:
            <span class="rmb">¥{{dataInfo.courseSaleprice}}</span>
          </div>
          <el-row class="apply">
            <el-button type="primary" @click="apply">马上报名</el-button>
          </el-row>
        </div>
      </div>
      <div class="introduce bs">
        <p class="title">课程介绍</p>
        <div class="cont" v-html="dataInfo.courseContent">{{dataInfo.courseContent}}</div>
      </div>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/module";

export default {
  name: "offlineDetail",
  components: {
    HeadCom,
    FooterCom
  },
  data() {
    return {
      dataInfo: {},
      courseId: ''
    };
  },
  mounted() {
    this.courseId = this.$route.query.courseId;
    this.getDetail();
  },
  methods: {
    getDetail() {
      http
        .getOfflineDetail({
          courseId: this.courseId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.dataInfo = data.data.data;
            var courseName = this.dataInfo.courseName;
            sessionStorage.setItem("courseName", courseName);
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    apply() {
      this.$router.push({
        path: "/offlineApply",
        query: {
          courseId: this.courseId
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.target {
  line-height: 60px;
}
.detail {
  .left {
    width: 500px;
    height: 300px;
    background: #ffffff;
    padding: 12px;
    .img-wrap {
      display: inline-block;
      width: 100%;
      height: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .info {
    margin-left: 30px;
    .title {
      line-height: 60px;
      font-size: 20px;
    }
    .line {
      line-height: 32px;
      .hour {
        margin-left: 50px;
      }
    }
    .begin {
      padding: 10px;
      max-width: 400px;
      margin: 20px 0;
      color: #409eff;
      border: 2px solid #409eff;
      border-radius: 4px;
      font-weight: 600;
    }
    .price {
      line-height: 40px;
      .rmb {
        font-size: 18px;
        color: #f10909;
        margin-left: 10px;
      }
    }
    .apply {
      margin-top: 20px;
    }
  }
}
.introduce {
  background: #ffffff;
  margin: 30px 0;
  .title {
    line-height: 60px;
    border-bottom: 1px solid #dddddd;
    border-radius: 6px;
    padding: 0 20px;
  }
  .cont {
    padding: 20px;
    line-height: 24px;
    text-indent: 2em;
  }
}
</style>
